module.exports = __webpack_public_path__ + "img/ph_seal-check-fill.c37f94ce.svg";